import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { usePageTitle } from "@/lib/content";

export default function VerifyEmail() {
  usePageTitle("Verify Email — Sitebound", "Verify your Sitebound account email address.");
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("verifying");

  useEffect(() => {
    if (!token) {
      setState("error");
      return;
    }
    api
      .post("/auth/verify-email", { token })
      .then(() => setState("done"))
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div data-testid="verify-email-page" className="blueprint-grid">
      <div className="mx-auto flex min-h-[60vh] max-w-md flex-col justify-center px-4 py-24 text-center">
        {state === "verifying" && (
          <h1 className="font-display text-4xl font-extrabold uppercase tracking-tight text-slate-100">
            Verifying…
          </h1>
        )}
        {state === "done" && (
          <>
            <div className="mono-label">Email verified</div>
            <h1 className="font-display mt-4 text-4xl font-extrabold uppercase tracking-tight text-slate-100">
              You're verified
            </h1>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              Any guest purchases made with this email address are now linked to your account.
            </p>
            <Link
              data-testid="verify-success-account-link"
              to="/account"
              className="mt-8 inline-block bg-[#FF5500] px-7 py-3.5 text-sm font-bold uppercase tracking-widest text-white hover:bg-[#E04800]"
            >
              Go to my account
            </Link>
          </>
        )}
        {state === "error" && (
          <>
            <div className="mono-label">Link invalid</div>
            <h1 className="font-display mt-4 text-4xl font-extrabold uppercase tracking-tight text-slate-100">
              This link has expired
            </h1>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              Verification links work once and expire after 24 hours. Sign in and use the resend option
              on your account page to get a fresh one.
            </p>
            <Link
              data-testid="verify-error-account-link"
              to="/account"
              className="mt-8 inline-block border border-white/25 px-7 py-3.5 text-sm font-bold uppercase tracking-widest text-slate-100 hover:border-[#FF5500] hover:text-[#FF5500]"
            >
              Go to account
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
